import { render, staticRenderFns } from "./BugoJangView.vue?vue&type=template&id=63239720&scoped=true&"
import script from "./BugoJangView.vue?vue&type=script&lang=js&"
export * from "./BugoJangView.vue?vue&type=script&lang=js&"
import style0 from "./BugoJangView.vue?vue&type=style&index=0&id=63239720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63239720",
  null
  
)

export default component.exports